import Axios, { AxiosResponse } from "axios";
import defineHeaderAxios from "@/utilities/useAuthToken";
import { ref } from "@vue/composition-api";
export default function () {
    const consumptionData = ref<Array<ConsumptionDataPoint>>([]);
    const getConsumptionData = async (
        meterId: string,
        daysBack: number
    ): Promise<Array<ConsumptionDataPoint>> => {
        await defineHeaderAxios();
        return Axios.get(`/api/Consumption/${meterId}/${daysBack}`)
            .then((result: AxiosResponse<Array<ConsumptionDataPoint>>) => {
                if (result.status === 200) {
                    consumptionData.value = result.data;
                    return result.data;
                } else return new Array<ConsumptionDataPoint>();
            })
            .catch((error) => {
                console.log(error);
                return new Array<ConsumptionDataPoint>();
            });
    };
    return {
        getConsumptionData,
        consumptionData,
    };
}

export class ConsumptionDataPoint {
    kilowatts: number;
    date: Date;
}
